module.exports = __webpack_public_path__ + "img/logo-white.cf1efe95.png";